import * as R from 'ramda'

import { convertFilterTypeToIndex, generateDateRanges } from 'shared/components/DateRangePicker/utils'
import { convertAnswerFilterResponseToRules } from 'libs/convertAdvanceFilter/utils'
import { getWorkspaceWeekStartDay } from 'libs/date'
import { encodeFilterToUrlParam } from 'shared/components/FilterGroupV2/utils'

export default function generateViewFilterToken(
  view,
  options,
  weekStartDay = getWorkspaceWeekStartDay()
) {
  const dateFilterType = R.prop('date_filter_type', view)
  const dateRange = [R.prop('start_date', view), R.prop('end_date', view)]
  if (!R.isNil(dateRange) && !R.isNil(dateFilterType)) {
    const advancedFilter = R.prop('advanced_filters', view)
    const advancedFilterGroups = R.prop('groups', advancedFilter)
    const hasFilterGroups = advancedFilterGroups?.length > 0
    const globalOperator = advancedFilter?.['global_operator'] || 'and'
    const filterRules = convertAnswerFilterResponseToRules(advancedFilter, options)

    const advancedFilterQuery = hasFilterGroups
      ? {
          globalOperator,
          groups: filterRules,
        }
      : {
          condition: 'and',
          rules: filterRules,
        }

    let dateRangeFilterQuery = {}
    if (dateFilterType != 0) {
      const presetDaterange = generateDateRanges(true, weekStartDay)
      const selectedPresetIndex = convertFilterTypeToIndex(dateFilterType)
      const selectDateRange = R.path([selectedPresetIndex, 'dateRange'], presetDaterange)
      dateRangeFilterQuery = {
        open: false,
        dateRange: selectDateRange,
        selectedPresetIndex: selectedPresetIndex,
      }
    } else {
      dateRangeFilterQuery = {
        open: false,
        dateRange: dateRange,
        selectedPresetIndex: null,
      }
    }

    const state = { advancedFilterQuery, dateRangeFilterQuery }
    const search = encodeFilterToUrlParam(state)
    return search
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/generateViewFilterToken/index.js